/* Where the websockets live.
 *
 * The address used to come solely from REACT_APP_WEBSOCKET_URL, read from
 * frontend/.env.local. That file is gitignored, so it exists only on machines
 * where somebody created it - the production server has one, which is why the
 * deployed bundle has always carried wss://www.soup.red/. A build anywhere
 * else got `undefined` and no working socket, and beforebuild.py's disabled
 * rewrite step was the only thing that had ever papered over that.
 *
 * So the variable still wins when it is set, and the page supplies the answer
 * when it is not. Deriving cannot disagree with where the app is running, and
 * it removes the build's dependency on an untracked file.
 */

const pointsAtLocalhost = (value) =>
  /(\/\/|^)(localhost|127\.0\.0\.1|\[::1\])(:|\/|$)/i.test(value);

const runningOnLocalhost = (hostname) =>
  ["localhost", "127.0.0.1", "[::1]", "::1"].includes(hostname);

export const getWebsocketBaseURL = () => {
  if (typeof window === "undefined") return "/";

  const { protocol, hostname, host, port } = window.location;
  const configured = process.env.REACT_APP_WEBSOCKET_URL;

  /* An explicit value still wins, so the API can be pointed at another host -
     unless it names localhost while the page is served from somewhere else.
     That combination is never what anybody meant: it is a developer's .env
     that has followed the build onto a server. Deriving is the safer answer
     there, so it takes over. */
  if (configured && !(pointsAtLocalhost(configured) && !runningOnLocalhost(hostname))) {
    return configured.endsWith("/") ? configured : `${configured}/`;
  }

  const scheme = protocol === "https:" ? "wss:" : "ws:";

  // The dev server serves the app on 3000 and proxies the API on 8000; a
  // websocket cannot go through that proxy, so it addresses 8000 directly.
  // Everywhere else the app and its sockets share an origin behind nginx.
  const target = port === "3000" ? `${hostname}:8000` : host;

  return `${scheme}//${target}/`;
};
